module.exports = __webpack_public_path__ + "static/media/bluesky-icon.5cb2cde5.png";